import { __awaiter, __generator } from "tslib";
import { BankCardSystem, PaymentMethodType } from '../types';
import * as api from '../api';
function formatCardNumber(str) {
    var PAN_SIZE = 16;
    var addMask = function (_, start, end) {
        var mask = '*'.repeat(PAN_SIZE - start.length - end.length);
        return "" + start + mask + end;
    };
    return str
        .replace(/\s/g, '')
        .replace(/(\d+)\*+(\d+)/, addMask)
        .replace(/([*\d]{4})/g, '$1 ')
        .trim();
}
function normalizeCards(cards) {
    return cards
        .sort(function (card1, card2) { return (card2.last_paid_ts - card1.last_paid_ts) || 0; })
        .map(function (rawCard) {
        var system = rawCard.system.toLowerCase();
        var partnerInfo = rawCard.partner_info;
        var card = {
            id: rawCard.id,
            type: PaymentMethodType.card,
            number: formatCardNumber(rawCard.number),
            system: BankCardSystem.unknown
        };
        switch (system) {
            case 'visa':
                card.system = BankCardSystem.visa;
                break;
            case 'mastercard':
                card.system = BankCardSystem.mastercard;
                break;
            case 'maestro':
                card.system = BankCardSystem.maestro;
                break;
            case 'mir':
                card.system = BankCardSystem.mir;
                break;
        }
        if (partnerInfo) {
            var yabankCardLabels = partnerInfo.yabank_card_labels, isYabankCard = partnerInfo.is_yabank_card, isYabankCardOwner = partnerInfo.is_yabank_card_owner;
            if (isYabankCard && isYabankCardOwner && (!yabankCardLabels || yabankCardLabels.length === 0)) {
                yabankCardLabels = ['YANDEX_BANK_PLUS_CARD'];
            }
            card.partnerInfo = {
                isYabankCard: isYabankCard,
                isYabankCardOwner: isYabankCardOwner,
                yabankCardLabels: yabankCardLabels,
            };
        }
        return card;
    });
}
export default function loadCards(apiHost, options) {
    if (options === void 0) { options = {}; }
    return __awaiter(this, void 0, void 0, function () {
        var cards;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, api.loadBoundCards(apiHost, options.serviceToken)];
                case 1:
                    cards = _a.sent();
                    return [2, normalizeCards(cards)];
            }
        });
    });
}
